import { Tooltip } from "@constellation-academy/epic-ui";
import React, { type PropsWithChildren, useId } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "@i18n/hooks";
import { type CopyTableIdButtonProps } from "./copy-table-id-button.types";

export const CopyTableIdButton = ({ id, children }: PropsWithChildren<CopyTableIdButtonProps>) => {
	const idToUse = useId().replace(":", "").replace(":", "");
	const { t } = useTranslation("common");
	const handleOnClick = () => {
		void navigator.clipboard.writeText(id);
		toast.success(t("messages.copiedToClipboard"));
	};
	return (
		<>
			<Tooltip target={`#${idToUse}`} content={`Copy ${id}`} />
			<div className="cursor-pointer" onClick={handleOnClick}>
				<div>
					{children}
					<i id={idToUse} className="pi pi-copy"></i>
				</div>
			</div>
		</>
	);
};
